// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__2bzHf","assignButton":"CreateEditEquipmentSchedule_assignButton__1wp5H"};